<template>
  <el-container class="classManger">
    <el-aside class="sidebar">
      <el-button
        v-auth="'paperRequire_/campus/addCampus'"
        type="text"
        style="float: right; margin-top: 5px; margin-right: 10px"
        @click="openCampusDialog(1)"
        icon="el-icon-plus"
        >考证项目</el-button
      >
      <div class="title">考试类别</div>
      <div class="campusManage-search">
        <el-tree
          :data="ChapterTree"
          :props="ChapterProps"
          :default-expanded-keys="[chapterForm.id]"
          :highlight-current="true"
          :expand-on-click-node="false"
          class="research-tree"
          ref="tree"
          node-key="id"
          current-node-key
        >
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span :title="data.name" @click="choseChapterId(data, node)">{{
              data.name
            }}</span>
          </span>
        </el-tree>
      </div>
    </el-aside>
    <el-main class="sidebarRight">
      <el-card>
        <el-row :gutter="20" style="height: 35px">
          <el-col :sm="12" :md="5" :lg="5">
            <div class="textWord">初级会计职称</div>
          </el-col>
          <el-col :sm="12" :md="5" :lg="5">
            <el-switch
              v-auth="'paperRequire_/campus/active'"
              v-model="switchValue"
              :active-value="1"
              :inactive-value="-1"
              @change="isActive()"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </el-col>
          <el-col :sm="12" :md="5" :lg="9" style="float: right">
            在分数有效期内要求课程合格后可以颁发证书
          </el-col>
        </el-row>
        <!-- <el-input v-model="inp" style="width:350px;margin:20px 0;" placeholder="请输入校区名称">
              <div slot="append">
                <el-button @click="getPageList()" class="search">查询</el-button>
              </div>
            </el-input>
        <el-button type="primary" @click="showAddDialog = true" icon="el-icon-plus">添加校区</el-button>-->
        <el-table
          v-auth="'paperRequire_/campus/pageList'"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          class="teacherTable"
          :data="tableData"
          border
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="考试课程"
            sortable
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column label="评分规则" align="center">
            <template slot-scope="">
              <!-- <el-button type="text" @click="isActive(scope.row)">{{scope.row.active==1?'启用':'禁用'}}</el-button> -->
            </template>
          </el-table-column>
          <el-table-column prop="name" label="合格分数" align="center"></el-table-column>
          <el-table-column label="分数有效期" align="center">
            <template>
              <!-- <el-button
                type="text"
                @click="campusShow = true,getCampusList(),openEditCampusDialog(4,scope.row)"
              >编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="table_bottom">
          <!-- <el-pagination
            style="float: left;"
            background
            layout="prev, pager, next, jumper,  total, sizes"
            :total="total"
            :page-size.sync="pageSize"
            :current-page.sync="currentPage"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination> -->
          <el-row :gutter="20" style="height: 60px">
            <el-col :sm="12" :md="5" :lg="11">
              <el-button
                @click="addPaperList()"
                class="search"
                v-auth="'paperRequire_addPaperList'"
                >添加课程</el-button
              >
            </el-col>
            <el-col :sm="12" :md="5" :lg="9" v-auth="'paperRequire_/campus/pageList'">
              <div class="classStudy-header selectData">
                <label>有效期:</label>
                <el-cascader
                  clearable
                  v-model="courseIds"
                  :show-all-levels="false"
                ></el-cascader>
                <!-- <el-cascader
                    clearable
                    v-model="courseIds"
                    :show-all-levels="false"
                    :props="subjectTreeProps"
                    :options="subjectTreeList"
                  ></el-cascader> -->
                <!-- <el-radio v-model="radio"></el-radio> -->
              </div>
            </el-col>
            <el-col :sm="12" :md="5" :lg="4" v-auth="'paperRequire_/campus/pageList'">
              <div class="classStudy-header selectData">
                <el-radio v-model="radio" label="1">当次有效</el-radio>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="clear: both"></div>
      </el-card>
      <!-- 添加校区
      <el-dialog
        @close="clearForm"
        class="addDialog"
        :title="addCampusName"
        :width="addwidth"
        :visible.sync="addCampusDialog"
      >
        <el-form
          :model="addCampusForm"
          status-icon
          :rules="rules"
          ref="addCampusForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item v-if="campusShow == true" label="所属校区" prop="parentId">
            <el-cascader
              style="width:100%;"
              clearable
              v-model="addCampusForm.parentId"
              :show-all-levels="false"
              :props="CampusProps"
              placeholder="请选择所属校区"
              :options="campusList"
            ></el-cascader>
          </el-form-item> 
          <el-form-item :label="campusLableName" prop="name">
            <el-input v-model="addCampusForm.name" autocomplete="off" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item v-if="showAbbreviationName" :label="shortName" prop="shortName">
            <el-input v-model="addCampusForm.shortName" autocomplete="off" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="active">
            <el-radio-group v-model="addCampusForm.active">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="-1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button @click="clearAddCampusForm">重置</el-button>
            <el-button type="primary" @click="addCampus">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog> -->

      <!-- 编辑校区 -->
      <!-- <el-dialog
        @close="clearForm"
        class="addDialog"
        :title="editCampusName"
        :width="addwidth"
        :visible.sync="editCampusDialog"
      >
        <el-form
          :model="editCampusForm"
          status-icon
          :rules="rules"
          ref="editCampusForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item v-if="campusShow == true" label="所属校区" prop="parentId">
            <el-cascader
              style="width:100%;"
              clearable
              v-model="editCampusForm.parentId"
              :show-all-levels="false"
              :props="CampusProps"
              placeholder="请选择所属校区"
              :options="campusList"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="campusLableName" prop="name">
            <el-input v-model="editCampusForm.name" autocomplete="off" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item v-if="showAbbreviationName" :label="shortName" prop="shortName">
            <el-input v-model="editCampusForm.shortName" autocomplete="off" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="active">
            <el-radio-group v-model="editCampusForm.active">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="-1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button @click="clearEditCampusForm">重置</el-button>
            <el-button type="primary" @click="updateCampus">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog> -->
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      courseIds: "",

      mousemoveShow: "",
      addCampusName: "添加省份",
      editCampusName: "编辑部门",
      campusLableName: "",
      shortName: "",
      showAbbreviationName: false,
      id: "", //校区id
      showEditorDialog: false,
      showAddDialog: false,
      loading: true, //表格是否加载中
      inp: "", //输入框绑定的值
      defaultProps: {
        children: "list",
        label: "name",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      campusShow: false,
      NodeClick: true,
      ChapterTree: [],
      ChapterProps: {
        children: "children",
        label: "name",
      },
      chapterForm: {
        id: 0,
        type: 1,
        courseId: null,
      },
      form: {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: "",
      },
      addCampusForm: {
        parentId: "",
        name: "",
        active: 1,
        level: 1,
        shortName: "",
      },
      editCampusForm: {
        campusId: "",
        shortName: "",
      },
      addCampusDialog: false,
      editCampusDialog: false,
      CampusTreeData: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
        checkStrictly: true,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入教室名称",
            trigger: "blur",
          },
        ],
        parentId: [
          {
            required: true,
            message: "请选择校区",
            trigger: "change",
          },
        ],
        active: [
          {
            required: true,
            message: "请选择是否禁用",
            trigger: "change",
          },
        ],
      },
      addwidth: "30%",
      campusList: [],
      campusId: null,
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10,
        },
        {
          value: 20,
          label: 20,
        },
      ],
      total: 0,
      switchValue: "",
      radio: "1",
    };
  },
  methods: {
    sizeChange() {
      this.pageChange();
    },
    currentChange() {
      this.pageChange();
    },
    pageChange() {
      //分页发生变化时
      let data;
      if (this.inp && !this.campusId) {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          name: this.inp,
          campusId: this.campusId,
        };
      } else {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          name: this.inp,
          campusId: this.campusId,
        };
      }
      this.api.campus.pageList(data).then((result) => {
        if (result.success) {
          this.loading = false;
          this.tableData = result.data.records;
        }
      });
    },
    paginationInit() {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
    },
    updateClassroom() {
      this.$refs.updateForm.validate((val) => {
        if (val) {
          let form = {};
          Object.assign(form, this.form, { id: this.id });
          this.api.classroom.updateClassroom(form).then((result) => {
            if (result.success) {
              this.showEditorDialog = false;
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.$message.success(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    isActive(v) {
      console.log(555);
      //是否启用
      let data = {
        id: v.id,
        active: v.active == "1" ? "1" : "-1",
      };
      this.api.campus.active(data).then((result) => {
        if (result.success) {
          this.$message.success(result.message);
          this.getPageList();
        } else {
          this.$message.error(result.message);
          this.getPageList();
        }
      });
    },
    del(v) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then((result) => {
          this.api.classroom.deleteClassroom([{ id: v.id }]).then((result) => {
            if (result.success) {
              this.showEditorDialog = false;
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.$message.success(result.message);
            }
          });
        })
        .catch(() => {});
    },
    getCampusTree() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((res) => {
          this.CampusTreeData = res.data;
          if (this.CampusTreeData.length === 0) {
            this.loading = false;
            this.$message.error("暂无校区，请添加校区");
          }
          let data = this.CampusTreeData[0];
          if (data.children.length > 0) {
            this.campusId = data.id;
            this.getPageList();
            let item = data.children[0];
            if (item.children.length > 0) {
              let items = item.children[0];
              if (items.children.length > 0) {
                let itemss = items.children[0];
                if (itemss.children.length > 0) {
                } else {
                  this.form.campusId = data.children[0].children[0].children[0].id;
                  // this.campusId = data.children[0].children[0].children[0].id;
                  // this.getPageList();
                }
              } else {
                this.form.campusId = data.children[0].children[0].id;
                // this.campusId = data.children[0].children[0].id;
                // this.getPageList();
              }
            } else {
              this.form.campusId = data.children[0].id;
              // this.campusId = data.children[0].id;
              // this.getPageList();
            }
          } else {
            this.form.campusId = data.id;
            this.campusId = data.id;
            this.getPageList();
          }
          this.$nextTick(function () {
            this.$refs.tree.setCurrentKey(this.campusId);
          });
        })
        .catch((error) => {});
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleNodeClick(data) {
      if (this.NodeClick == true) {
        if (data.children.length > 0) {
          let item = data.children[0];
          if (item.children.length > 0) {
            let items = item.children[0];
            if (items.children.length > 0) {
              this.addCampusForm.parentId = data.children[0].children[0].id;
            } else {
              this.addCampusForm.parentId = data.children[0].children[0].id;
            }
          } else {
            this.addCampusForm.parentId = data.children[0].id;
          }
        } else {
          this.addCampusForm.parentId = data.id;
        }
        this.campusId = data.id;
        this.getPageList();
      }
    },
    openCampusDialog(level, id) {
      if (level) {
        if (level === 1) {
          this.addCampusName = "添加省份";
          this.campusLableName = "省份名称";
          this.shortName = "省份简称";
          this.showAbbreviationName = true;
        }
        if (level === 2) {
          this.addCampusName = "添加城市";
          this.campusLableName = "城市名称";
          this.shortName = "城市简称";
          this.showAbbreviationName = true;
        }
        if (level === 3) {
          this.addCampusName = "添加校区";
          this.campusLableName = "校区名称";
          this.shortName = "校区简称";
          this.showAbbreviationName = true;
        }
        if (level === 4) {
          this.addCampusName = "添加部门";
          this.campusLableName = "部门名称";
          this.showAbbreviationName = false;
        }
        if (level !== 4) {
          this.addCampusForm.level = level;
        }
      } else {
        this.addCampusForm.level = 1;
      }
      if (id) {
        this.addCampusForm.parentId = id;
      } else {
        this.addCampusForm.parentId = "";
      }
      this.addCampusDialog = true;
    },
    openEditCampusDialog(level, data) {
      if (level === 1) {
        this.editCampusName = "编辑省份";
        this.campusLableName = "省份名称";
        this.shortName = "省份简称";
        this.showAbbreviationName = true;
      }
      if (level === 2) {
        this.editCampusName = "编辑城市";
        this.campusLableName = "城市名称";
        this.shortName = "城市简称";
        this.showAbbreviationName = true;
      }
      if (level === 3) {
        this.editCampusName = "编辑校区";
        this.campusLableName = "校区名称";
        this.shortName = "校区简称";
        this.showAbbreviationName = true;
      }
      if (level === 4) {
        this.editCampusName = "编辑部门";
        this.campusLableName = "部门名称";
        this.showAbbreviationName = false;
      }
      this.editCampusForm.id = data.id;
      this.getCampus(data.id);
      this.editCampusDialog = true;
    },
    getCampus(data) {
      this.api.campus.getCampus({ id: data }).then((result) => {
        if (result.success) {
          this.editCampusForm = result.data;
          if (this.editCampusForm.parentId === "1") {
            this.editCampusForm.parentId = "";
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    addCampus() {
      this.$refs.addCampusForm.validate((val) => {
        if (val) {
          if (typeof this.addCampusForm.parentId == "object") {
            let index = this.addCampusForm.parentId.length;
            this.addCampusForm.parentId = this.addCampusForm.parentId[index - 1];
          }
          if (this.campusShow == true) {
            this.addCampusForm.level = 4;
          }
          this.api.campus.addCampus(this.addCampusForm).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.addCampusDialog = false;
              this.campusShow = false;
              this.showAbbreviationName = false;
              this.getCampusTree();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    updateCampus() {
      this.$refs.editCampusForm.validate((val) => {
        if (val) {
          if (typeof this.editCampusForm.parentId == "object") {
            let index = this.editCampusForm.parentId.length;
            this.editCampusForm.parentId = this.editCampusForm.parentId[index - 1];
          }
          this.api.campus.updateCampus(this.editCampusForm).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.editCampusDialog = false;
              this.campusShow = false;
              this.getCampusTree();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    deleteCampus(id, level) {
      let name = "";
      if (level === 1) {
        name = "省份（关联子校区）";
      }
      if (level === 2) {
        name = "城市（关联子校区）";
      }
      if (level === 3) {
        name = "校区";
      }
      if (level === 4) {
        name = "部门";
      }
      this.$confirm("将会删除此" + name + "，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.campus.deleteCampus([{ id: id }]).then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            this.getCampusTree();
            this.NodeClick = true;
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    getPageList() {
      this.loading = true;
      let data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        name: this.inp,
        campusId: this.campusId,
      };
      this.loading = true;
      this.api.campus.pageList(data).then((result) => {
        if (result.success) {
          this.tableData = result.data.records;
          this.total = Number(result.data.total);
          this.loading = false;
          this.paginationInit();
        }
      });
    },
    // setIdEvent(val) {
    //   this.campusId = val.id;
    //   this.pageSize = 10;
    //   this.currentPage = 1;
    //   this.inp = "";
    //   var data = {
    //     pageNumber: this.currentPage,
    //     pageSize: this.pageSize,
    //     sortName: "create_time",
    //     sortOrder: "desc",
    //     campusId: val.id
    //   };
    //   this.api.classroom.pageList(data).then(result => {
    //     // console.log(result)
    //     if (result.success) {
    //       this.tableData = result.data.records;
    //     }
    //   });
    // },
    // getCampusTree() {
    //   this.api.campus
    //     .getCampusTree({parentId:1})
    //     .then(res => {
    //       this.CampusTreeData = res.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    setaddDialogwidth() {
      //设置添加老师弹窗大小
      var width = document.body.clientWidth;
      if (width < 560) {
        this.addwidth = "80%";
      } else if (width < 790) {
        this.addwidth = "70%";
      } else if (width < 970) {
        this.addwidth = "50%";
      } else if (width < 1300) {
        this.addwidth = "40%";
      } else {
        this.addwidth = "30%";
      }
    },
    clearForm() {
      this.form = {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: "",
      };
    },
    clearAddCampusForm() {
      this.addCampusForm.name = "";
      this.addCampusForm.parentId = "";
      this.addCampusForm.active = 1;
      this.showAbbreviationName = false;
    },
    clearEditCampusForm() {
      this.editCampusForm.name = "";
      this.editCampusForm.parentId = "";
      this.editCampusForm.active = 1;
    },
    addClassRoom() {
      this.$refs.addForm.validate((val) => {
        if (val) {
          this.api.classroom.addClassroom(this.form).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.getPageList();
              this.clearForm();
              this.showAddDialog = false;
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    //获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  if (items.children) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            // this.subjectTreeList = result.data;
            this.ChapterTree = result.data;
            console.log(result.data);
            this.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.searchForm.courseId = this.subjectTreeList[0].children[0].children[0].id;
            this.chapterForm.courseId = this.subjectTreeList[0].children[0].children[0].id;
            this.getTree();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //点击按钮添加一行表格
    addPaperList() {
      this.tableData.push({});
    },
  },
  watch: {
    addCampusDialog: function (newVal) {
      if (!newVal) {
        this.campusShow = false;
        this.$refs.addCampusForm.resetFields();
        this.addCampusForm.parentId = "";
        this.addCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
    editCampusDialog: function (newVal) {
      if (!newVal) {
        this.campusShow = false;
        this.$refs.editCampusForm.resetFields();
        this.editCampusForm.parentId = "";
        this.editCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
  },
  created() {
    this.getCampusTree();
  },
  mounted() {
    window.onresize = () => {
      this.setaddDialogwidth();
    };
    this.getSubjectTreeList();
  },
};
</script>
<style scoped>
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.textWord {
  color: #999;
  font-weight: bold;
}
.selectData {
  display: flex;
}
.selectData label {
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}
.sidebarRight >>> .switchStyle .el-switch__label--left {
  left: 26px;
}
.sidebarRight >>> .switchStyle .el-switch__label--right {
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/goExamRequire.vue